import { useEffect, useRef, useState } from "react";

const NUM = /\d[\d,]*(\.\d+)?/g;
const render = (value, t) => value.replace(NUM, (n) => Math.round(parseFloat(n.replace(/,/g, "")) * t).toLocaleString("en-US"));

export const CountUp = ({ value, duration = 1200, delay = 0, className = "", testId }) => {
  const ref = useRef(null);
  const [t, setT] = useState(0);

  useEffect(() => {
    const node = ref.current;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) {
      setT(1);
      return undefined;
    }
    let raf = 0, timer = 0;
    const io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      io.disconnect();
      timer = window.setTimeout(() => {
        const start = performance.now();
        const step = (now) => {
          const p = Math.max(0, Math.min(1, (now - start) / duration));
          setT(1 - Math.pow(1 - p, 3));
          if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
      }, delay);
    }, { threshold: 0.4 });
    io.observe(node);
    return () => { io.disconnect(); window.clearTimeout(timer); cancelAnimationFrame(raf); };
  }, [duration, delay]);

  return (
    <span ref={ref} className={className} data-testid={testId} data-final={value} aria-label={value}>
      {t >= 1 ? value : render(value, t)}
    </span>
  );
};
